import { Field } from 'formik';
import React, { useEffect } from 'react';

const Select = ({ field, form, options, placeholder, optionValue, optionLabel, className, ...props }: any) => {
  useEffect(() => {}, [options]);

  return (
    <div className={`relative h-12 w-full mt-2 min-w-[200px] ${className}`}>
      <Field
        as='select'
        {...field}
        className='peer h-full w-full rounded-[7px] border-2 border-neutral-800 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-white outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-primary placeholder-shown:border-t-primary empty:!bg-gray-900 focus:border-2 focus:border-primary focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50'
      >
        <option className='text-white/40' defaultValue=''>
          Select one
        </option>
        {options.map((option: any) => {
          return (
            <option
              className='text-white'
              key={optionValue ? option[optionValue] : option['id']}
              value={optionValue ? option[optionValue] : option['id']}
            >
              {optionValue ? option[optionLabel] : option['name']}
            </option>
          );
        })}
      </Field>
      <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-white transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t-2 before:border-l-2 before:border-neutral-800 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t-2 after:border-r-2 after:border-neutral-800 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-white peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-white peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-primary peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-primary peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-white">
        {placeholder}
      </label>
      {/* <Field
        as='select'
        {...field}
        className='bg-gray-50 focus:outline-none text-gray-900 text-sm rounded-lg   block w-full p-2.5 dark:bg-gray-700  dark:placeholder-gray-400 dark:text-white  '
      >
        <option defaultValue=''>{placeholder ? placeholder : 'Select'}</option>
        {options.map((option: any) => {
          return (
            <option
              key={optionValue ? option[optionValue] : option['id']}
              value={optionValue ? option[optionValue] : option['id']}
            >
              {optionValue ? option[optionLabel] : option['name']}
            </option>
          );
        })}
      </Field> */}
    </div>
  );
};

export default Select;
